/******/
(() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsHyperPop = {
    init: function($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsHyperPop = $.extend(this, window.PXUTheme.getSectionData($section));
      
      // window.PXUTheme.jsHyperPop.preLoader();
  
      // window.PXUTheme.jsHyperPop.topPadding();
      window.PXUTheme.jsHyperPop.runMasonry();

      /* $(window).on('resize', function() {
           window.PXUTheme.jsHyperPop.topPadding();
        });*/
    },
    topPadding: function () {
      let menuHeight = $('#shopify-section-header-search-focus-static').outerHeight(),
        newPadding = menuHeight + 20;
      $('#hyperpop-wrap').css('padding-top', newPadding + 'px');
      window.PXUTheme.jsHyperPop.preLoader();
    },
    animateTimeline: function(){
      const jsHyperPop = window.PXUTheme.jsHyperPop,
            sections = gsap.utils.toArray('#hyperpop-container > .section'),
            navLinks = gsap.utils.toArray('.timeline-section');
      let tl = gsap.timeline();
      sections.forEach((section, i) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top center",
          markers: true,
          onEnter: () => {
            let navLink = navLinks[i];
            if(navLink) {
              let $jqLink = $(navLink),
                  linkMiddle = $jqLink.position().top + ($jqLink.outerHeight() / 2);
              gsap.to('#timeline-inner', {y: linkMiddle});
            }
          },
          onEnterBack: () => {
            let navLink = navLinks[i];
            if(navLink) {
              let $jqLink = $(navLink),
                  linkMiddle = $jqLink.position().top + ($jqLink.outerHeight() / 2);
              gsap.to('#timeline-inner', {y: linkMiddle});
            }
          }
        })
      });

    },
    getPosition: function(el) {
      let middleY = el.position().top + (el.outerHeight() / 2);
      return middleY;
    },
    runMasonry: function() {
      // Run Masonry function in utilities.js
      window.PXUTheme.applyMasonry('.gallery__grid-item', 10, '.image-matrix', '.grid__sizer');
    },
    preLoader: function() {
      // $(window).on('load', function() { // makes sure the whole site is loaded 
          $('#status').fadeOut(); // will first fade out the loading animation 
          $('#preloader').delay(250).fadeOut('slow'); // will fade out the white DIV that covers the website. 
          $('body').delay(250).css({'overflow':'visible'});
          console.log('Welcome to HYPER POP!');
      // })
    },
    unload: function($section) {
    }
  }

  /******/
})();